import { QuizQuestion } from './QuizQuestion';
import { usePageLeave } from '../usePageLeave';
import { ProgressBar } from '../../../components';
import type { QuizType } from '../../../api';
import type { AnswersContainerType } from '../useQuiz';

export type QuizPlaygroundProps = {
  quiz: QuizType | null;

  isMobile?: boolean;
  questionId?: string;
  questionIndex: number;
  answers: AnswersContainerType;

  handleAnswerQuestion: (questionId: string, answer: string) => void;
};

export const QuizPlayground: React.FC<QuizPlaygroundProps> = ({
  quiz,
  answers,
  isMobile,
  questionIndex,

  handleAnswerQuestion,
}) => {
  usePageLeave();

  const questionsCount = quiz?.questions?.length || 0;
  const question = quiz?.questions?.[questionIndex];

  return (
    <div>
      <div className="mb-lg flex items-center">
        <ProgressBar
          color="bg-main"
          progressPercent={((questionIndex + 1) / questionsCount) * 100}
          containerClassName="flex-row-reverse items-center py-sm mr-md px-md justify-center bg-progressBackground border-transparent rounded-xs"
          label={
            <div className="mr-xs text-small font-semibold">
              {questionIndex + 1}/{questionsCount}
            </div>
          }
        />
      </div>
      <QuizQuestion
        question={question}
        isMobile={isMobile}
        questionIndex={questionIndex}
        answer={answers[question?.questionId!]}
        handleAnswerQuestion={handleAnswerQuestion}
      />
    </div>
  );
};
